import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
	import { VCard } from 'vuetify/lib';
	import PageContainer from '@cnamts/vue-dot/src/elements/PageContainer';

	import RememberSection from '@/features/search-radiologist/components/remember-section/remember-section.vue';
	import SearchSection from '@/features/search-radiologist/components/search-section.vue';
	import StructureList from '@/features/search-radiologist/components/result-section/structure-list.vue';
	import StructuresMap from '@/features/search-radiologist/components/map-section/structures-map.vue';
	import { Structure } from '@/types/structure';
	import { GeoApiCity } from '@/types/geo-api-city';
	import { TraceEventService } from '@/services/trace-event-service';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'search-radiologist-page',
  setup(__props) {

	const structuresList = ref<Structure[]>([]);
	const city = ref<GeoApiCity>();
	const displayNotFoundAlert = ref(false);

	/**
	 * On trace l'accès à la page de recherche
	 */
	onMounted(() => TraceEventService.trace('ACCES'));

	/**
	 * Met à jour la liste des structures
	 * @param newStructuresList Liste des structures
	 */
	function handleChangeStructureList(newStructuresList: Structure[]): void {
		displayNotFoundAlert.value = !newStructuresList.length;
		structuresList.value = newStructuresList;
	}

	/**
	 * Met à jour la ville
	 * @param newCity Ville
	 */
	function handleChangeCity(newCity: GeoApiCity): void {
		city.value = newCity;
	}

return { __sfc: true,structuresList, city, displayNotFoundAlert, handleChangeStructureList, handleChangeCity, VCard, PageContainer, RememberSection, SearchSection, StructureList, StructuresMap }
}

})